import { __extends } from "tslib";
import { DeleteAdmChannelRequest, DeleteAdmChannelResponse } from "../models/index";
import { deserializeAws_restJson1DeleteAdmChannelCommand, serializeAws_restJson1DeleteAdmChannelCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var DeleteAdmChannelCommand = /** @class */ (function (_super) {
    __extends(DeleteAdmChannelCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DeleteAdmChannelCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    DeleteAdmChannelCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: DeleteAdmChannelRequest.filterSensitiveLog,
            outputFilterSensitiveLog: DeleteAdmChannelResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteAdmChannelCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1DeleteAdmChannelCommand(input, context);
    };
    DeleteAdmChannelCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1DeleteAdmChannelCommand(output, context);
    };
    return DeleteAdmChannelCommand;
}($Command));
export { DeleteAdmChannelCommand };
//# sourceMappingURL=DeleteAdmChannelCommand.js.map